import LoadingIndicator from '@copilot/common/components/loadingIndicator/spinner';
import { Suspense } from 'react';

/**
 * Lazy load a component with a loading indicator
 * @param LazyComponent - The component to lazy load
 * @returns A lazy loaded component
 */
export function withLazyComponent(LazyComponent: any) {
    return (props: any) => (
        <Suspense fallback={<LoadingIndicator isLoading={true} isFullScreen={true} />}>
            <LazyComponent {...props} />
        </Suspense>
    );
}
